package com.devi3east.bashbuddy.account.profile.domain.models

import com.devi3east.bashbuddy.common.domain.models.Address
import com.devi3east.bashbuddy.auth.domain.models.UserType
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class Profile(
    val _id: String = "",

    val email: String,
    val displayName: String? = null,
    val name: String? = null,
    val phone: String? = null,
    val profileImageUrl: String? = null,
    val address: Address? = null,

    val userType: UserType,

    val favorites: List<String> = emptyList(),

    val affiliatedOrganization: String? = null,

    val dateOfBirthInstant: Instant? = null,
    val certifiedOfAge: Boolean = false,
    val showCartInfoDialog: Boolean = true,
    val agreedToTermsOfService: Boolean = false,

    val createdAt: Instant? = null,

    val showFirstSignInDialog: Boolean = true,

    val isActive: Boolean = true
)